import styled from "styled-components";


export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const EditorActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const EditorButton = styled.button`
    display: flex;
    height: 32px;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    grid-gap: 8px;
    gap: 8px;
    border-radius: 5px;
    background: #2555ef;
    background: var(--blues-blue-main, #2555ef);
    color: #fff;
    color: var(--White, var(--White-100, #fff));
    font-size: 12px;
    font-weight: 500;
`